export default __webpack_public_path__ + "static/media/calendar.88fa8ff1.svg";